import {
  pipe,
  prop,
  toLower,
  equals,
  cond,
  T,
  always,
  prepend,
  join,
  complement,
  test,
  when
} from 'ramda'
import { UUID_SLUG } from '../../../constants'

const notAbsolute = complement(test(/^\//))

/**
 * Extract the `path` property from a navItem.
 * If the path doesn't start with a `/`, prepend one
 * so links don't break if you're not on the home screen.
 */
const getPath = pipe(
  prop('path'),
  when(notAbsolute, pipe(prepend('/'), join('')))
)

const isHome = pipe(prop('name'), toLower, equals('home'))
const toUUIDPath = pipe(prop('name'), name => `/${UUID_SLUG}/${name}`)
const toUUIDTarget = pipe(prop('target'), target => `/${UUID_SLUG}/${target}`)

/**
 * Extracts the path name from a navItem.
 * It looks for a not null `path`, `pathname` or `target` property,
 * then falls back on the `name` property, unless
 * the nav item points to home, in which case
 * no path is used.
 */
export const findPathName = cond([
  [prop('path'), getPath],
  [prop('target'), toUUIDTarget],
  [isHome, always('')],
  [T, toUUIDPath]
])

export const hasChildren = pipe(prop('children'), children => children?.length > 0)
